import translation from './translation';
import onboarding from './onboarding';
import terminals from './terminals';
import status from './status';
import employees from './employees';
import locations from './locations';
import transactions from './transactions';
import paymentDetails from './paymentDetails';
import accounts from './accounts';
import profile from './profile';
import payouts from './payouts';
import countries from './countries';
import languages from './languages';
import limits from './limits';
import kyc from './kyc';
import invitation from './invitation';
import oat from './oat';
import passwordReset from './passwordReset';
import noBusinessProfile from './noBusinessProfile';
import notAuthorized from './notAuthorized';
import errors from './errors';
import payrolls from './payrolls';
import * as handbook from './handbook';
import sendMoney from './sendMoney';

export default {
  translation,
  onboarding,
  terminals,
  status,
  employees,
  locations,
  transactions,
  paymentDetails,
  accounts,
  profile,
  payouts,
  countries,
  languages,
  limits,
  kyc,
  invitation,
  oat,
  passwordReset,
  noBusinessProfile,
  notAuthorized,
  errors,
  payrolls,
  ...handbook,
  sendMoney,
};
